import { render } from "./productionApply.vue?vue&type=template&id=0c678573&scoped=true"
import script from "./productionApply.vue?vue&type=script&lang=js"
export * from "./productionApply.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c678573"]])

export default __exports__